import * as insuranceRequest from '@/network/api/insurance.api.js'
import * as apiAccount from '@/network/api/accounts.api.js'

/** requests Accounts Balance
@return { promise } - Accounts Balance request
*/
export const requestAccountsBalances = async (context, payload) => {
    const res = await apiAccount.requestAccountsBalances(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_ACCOUNTS_BALANCE', data)
    }
    return res
}

/** requests holder data
@payload { Object }
@return { promise } - holder data request
*/
export const requestInsuranceHolder = async (context, payload) => {
    const res = await insuranceRequest.requestInsuranceHolder(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_HOLDER_DATA', data)
    }
    return res
}

/** requests domain data
@payload { Object }
@return { promise } - domain data request
*/
export const requestInsuranceDomainsList = async (context, payload) => {
    const res = await insuranceRequest.requestInsuranceDomainsList(payload)

    if (res && !payload.dontSave) {
        const data = res.data.data
        context.commit('SAVE_DOMAIN_DATA', { data: data, domainName: payload.domain })
    }

    return res
}

/** submits simulation
@payload { Object }
@return { promise } - simulation data request
*/
export const submitSimulation = async (context, payload) => {
    const res = await insuranceRequest.submitQuotation(payload)

    if (res) {
        const data = res.data.data
        context.commit('SAVE_QUOTATION', data)
    }

    return res
}

/** accepts simulation
@payload { Object }
@return { promise } - simulation data request
*/
export const acceptSimulation = async (context, payload) => {
    const res = await insuranceRequest.acceptQuotation(payload)

    return res
}

/** submits proposal
@payload { Object }
@return { promise } - proposal data request
*/
export const submitProposal = async (context, payload) => {
    const res = await insuranceRequest.submitProposal(payload)

    return res
}

/** requests receipts
@payload { Object }
@return { promise } - receipts list request
*/
export const requestReceiptsList = async (context, payload) => {
    const res = await insuranceRequest.getPolicyReceiptsList(payload)

    return res
}

/** requests documents
@payload { Object }
@return { promise } - documents list request
*/
export const requestDocumentsList = async (context, payload) => {
    const res = await insuranceRequest.getPolicyReceiptDocumentsList(payload)

    if (res) {
        const data = res.data.data
        context.commit('SAVE_DOCUMENTS', data)
    }

    return res.data.data
}
/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
export const clearFeatureStates = async (context, payload) => {
    context.commit('CLEAR_FEATURE_STATE')
}
